import {getElement, removeActive} from "../modules/helpers.js";
import {findVariationInProducts, getVariationFromAttributes, objectAttributesCreate} from "./productItem.js";
import {productItemSlider} from "./productPageSliders.js";
import {fixAttributeValue, getAlternativeColorPattern, getAlternativePhotoPreview} from "../modules/popups.js";


const productItem = getElement('.product-item__main');

export default function renderProductInfo() {

    const {
        productId,
        comments,
        attributes: {defaultAttributes, variationsAttributes, allAttributes},
        variations,
        thumbnail,
        isQuantity,
        quantityValue,
        plate,
        rating: {rating},
        modal_size
    } = product;
    const renderAttributes = allAttributes.filter(item => {
        for (let key of variationsAttributes) {
            if (key == Object.keys(item)[0]) {
                return item;
            }
        }
    });

    const priceParent = getElement('[data-variation-price]');
    const reviews = productItem.querySelector('.reviews-button');
    const reviewsCount = reviews.querySelector('[data-reviews]');

    productItem.dataset.productThumbnail = thumbnail;
    productItem.dataset.productId = productId;
    renderBreadcrumbs();
    renderRatingHTML(productItem, rating)
    reviews.dataset.modal = comments.length > 0 ? 'reviews' : 'empty';
    reviewsCount.dataset.reviews = comments.length > 0 ? comments.length : 0;
    reviewsCount.innerText = comments.length > 0 ? comments.length : 0;
    priceParent.dataset.productQuantity = quantityValue;
    renderVariationsAttributes(renderAttributes);

    const cummerbundSizeAttributeParent = getElement('.product-item__cummerbund-size');
    let productAttributes = null;
    let productDefaultAttributes = JSON.parse(JSON.stringify(defaultAttributes))
    if (location.search.match(/\?attribute_/)) {
        productAttributes = {};
        let attr = location.search.slice(1).split('&');
        attr = attr.filter(item => item.includes('attribute')).join('');
        attr.split('attribute_').forEach(el => {
            if (el) {
                const [key, value] = el.split('=');
                productAttributes[key] = value;
            }

        })
    }
    if (isLogin && personalInfo) {
        if (personalInfo.pa_color && findPersonalColor(personalInfo.pa_color, allAttributes)) productDefaultAttributes.pa_color = personalInfo.pa_color;
        if (personalInfo.personalized[modal_size]) {
            if (modal_size == 'bodySize') {
                let {bodySizeVest, bodySizeCummerband} = personalInfo.personalized[modal_size];
                if (bodySizeVest && findAttributeSlug(bodySizeVest, allAttributes)) {
                    productDefaultAttributes.pa_size = findAttributeSlug(bodySizeVest, allAttributes)

                }
                if (bodySizeCummerband && findAttributeSlug(bodySizeCummerband, allAttributes, "pa_cummerbund-size")) {
                    productDefaultAttributes['pa_cummerbund-size'] = findAttributeSlug(bodySizeCummerband, allAttributes, "pa_cummerbund-size")
                }
            } else {

                if (findAttributeSlug(personalInfo.personalized[modal_size], allAttributes)) productDefaultAttributes.pa_size = findAttributeSlug(personalInfo.personalized[modal_size], allAttributes)
            }


        }

    }
    const currentAttributes = productAttributes ? productAttributes : productDefaultAttributes;
    let defaultItem = findVariation(currentAttributes) ? findVariation(currentAttributes) : variations[0];
    const attributesElements = productItem.querySelector('.product-item__attributes').querySelectorAll('[data-select]');
    // if (product.plate) {
    //     defaultItem = findPlateVariation(currentAttributes)
    //     productItem.dataset.productId = defaultItem.id;
    // }

    renderActiveAttributes(attributesElements, defaultItem, defaultItem.price);
    productItem.dataset.productId = defaultItem.id;


    if (getElement('[data-fas]')) {
        createFasAttributes();
    }

    calcCashBack(productItem)
    if (isQuantity) {
        productItem.querySelector('.product-item__attributes').insertAdjacentHTML('afterend', renderQuantityChanger())
        productItem.querySelector('.cart__counter').querySelectorAll('button').forEach(item => {
            const counter = productItem.querySelector('.cart__counter').querySelector('.result');
            counter.innerText = quantityValue;
            item.addEventListener('click', () => {
                let result = +counter.innerText;
                if (item.firstElementChild.classList.contains('plus')) {
                    result = result + 1;
                    counter.innerText = result;
                    priceParent.dataset.productQuantity = result
                } else {
                    if (counter.innerText == 1) return;
                    result = result - 1;
                    counter.innerText = result;
                    priceParent.dataset.productQuantity = result;
                }
                getVariationFromAttributesMainProduct(attributesElements);
                installmentCalc(productItem);
                calcCashBack(productItem)

            })
        })
    }
    if (productItem.firstElementChild.offsetHeight < productItem.firstElementChild.scrollHeight) {
        // console.dir(productItem.firstElementChild)
    }
    setTimeout(() => {
        if (productItem.firstElementChild.offsetHeight < productItem.firstElementChild.scrollHeight) {
            productItem.querySelector('.product-item__order').classList.toggle('shadow--up')
        }
    }, 0)


    attributesElements.forEach(item => {
        const btns = item.querySelectorAll('button');
        installmentCalc(productItem);
        btns.forEach(btn => {
            btn.addEventListener('click', () => {
                removeActive(btns)
                btn.classList.add("active");
                getVariationFromAttributesMainProduct(attributesElements);
                if (getElement('[data-fas]')) {
                    createFasAttributes();

                }


                installmentCalc(productItem);
                calcCashBack(productItem);
            });

        })
    });
    if (cummerbundSizeAttributeParent) {
        const sizeAttribute = getElement('.product-item__size');
        const cummerbundSizeAttribute = cummerbundSizeAttributeParent.querySelector('[data-select]');
        const switcher = document.createElement('div');
        cummerbundSizeAttribute.classList.add('hide')
        switcher.classList = 'size-switcher flex';
        switcher.innerHTML = `
        <button class="active" data-switch = 'pa_size' data-type="vest">Vest</button>
        <button data-switch = 'pa_cummerbund-size' data-type="cummerbund">Cummerbund</button>
        `;
        switcher.dataset.toggle = 'true';
        sizeAttribute.append(cummerbundSizeAttribute);


        switcher.querySelectorAll('button').forEach(switchBtn => {
            sizeAttribute.querySelectorAll('[data-select]').forEach(item => {
                if (switchBtn.dataset.switch === item.dataset.select) {
                    item.dataset.sizeType = switchBtn.dataset.type;
                }
            })
            switchBtn.addEventListener('click', () => {
                removeActive(switcher.querySelectorAll('button'));
                switchBtn.classList.add('active')
                sizeAttribute.querySelectorAll('[data-select]').forEach(item => {
                    item.classList.add('hide')
                    item.classList.remove('show')
                    if (switchBtn.dataset.switch === item.dataset.select) {
                        item.classList.remove('hide')
                        item.classList.add('show')
                    }
                })

            })
        })
        sizeAttribute.querySelectorAll('[data-select]').forEach(item => {
            item.querySelectorAll('button').forEach(btn => {
                btn.addEventListener('click', () => {
                    if (item.dataset.select === 'pa_size' && switcher.dataset.toggle == 'true') {
                        sizeAttribute.querySelector('[data-select=pa_cummerbund-size]').querySelectorAll('button').forEach(cummerbundBtn => {
                            if (btn.dataset.pa_size === cummerbundBtn.dataset.pa_cummerbundSize) {
                                removeActive(sizeAttribute.querySelector('[data-select=pa_cummerbund-size]').querySelectorAll('button'));
                                cummerbundBtn.classList.add('active');
                                getVariationFromAttributesMainProduct(attributesElements)
                            }
                        })
                    }
                    if (item.dataset.select === 'pa_cummerbund-size') {
                        switcher.dataset.toggle = 'false';
                    }

                })
            })
        })
        sizeAttribute.firstElementChild.firstElementChild.insertAdjacentElement('afterend', switcher)
        cummerbundSizeAttributeParent.remove();
    }
    if (plate) {
        let linkStr = ''
        productItem.querySelector('[data-select="pa_size"]').querySelectorAll('[data-pa_size]').forEach(activeAttr => {
            if (activeAttr.classList.contains('active')) {
                linkStr = activeAttr.dataset.pa_size;
            }
        })
        plate.forEach(item => {
            const {name, links} = item
            const title = (name[0].toUpperCase() + name.slice(1)).split('_').join(' ')
            const div = document.createElement('div')

            const btns = function () {
                let fragment = ``;

                links.forEach((link) => {
                    const {attrName, href, id} = link
                    if (id == productId) {
                        return fragment += `
                  <button data-plate-id="${id}" class="btn btn--outline  --dir-col active">  <span>${attrName}</span></button>
                `

                    }
                    if (!id) return;
                    return fragment += `
                  <a  href="${href}?attribute_pa_size=${linkStr}" class="btn btn--outline  --dir-col">  <span>${attrName}</span></a>
                `
                })
                return fragment
            }

            div.classList = `product-item__${name} product-item--line border--bottom`;
            div.innerHTML =
                `<div class="flex --just-between  --align-center mb-10"><div class="mr-10">${title}</div></div>
                 <div class="product-item__buttons flex product-item__buttons--height-auto" data-plate>

                  ${btns()}
                  </div>`
            productItem.querySelector('[data-attributes]').querySelector('.product-item__size').insertAdjacentElement('beforebegin', div)
        })

    }

    const productInformation = getElement('.product-item__information');
    const productImages = productInformation.querySelector('.product-item__gallery ').querySelector('.photos');
    productImages.innerHTML = '';
    alternativeDropdown(defaultItem);
    if (getElement('[data-select="pa_color"]')) {


        getElement('[data-select="pa_color"]').querySelectorAll('button').forEach(item => {
            let color = '';
            if (item.classList.contains('active')) {
                color = item.dataset.pa_color;
                productImages.appendChild(renderProductGallery(color, productImages))
                productItemSlider()
            }
            item.addEventListener('click', () => {
                color = item.dataset.pa_color;
                productImages.appendChild(renderProductGallery(color, productImages))
                productItemSlider()
            })


        })
    } else {
        const {images: {photos, gallery, fieldFootage}, title} = product;
        const fragment = document.createDocumentFragment();
        let galleryArr = [];
        gallery.forEach(item => {
            if (item.main) {
                galleryArr = [...galleryArr, item.main,];
            }
        });
        if (!photos) return;
        photos.forEach(item => {
            if (item.colors) {
                galleryArr = [...galleryArr, item.colors[0].img];
            }
        });
        gallery.forEach(item => {
            if (!item.img) return;
            if (galleryArr.length == 3) return;
            galleryArr = [...galleryArr, item.img];
        });
        const imagesItems = 6 - galleryArr.length;
        if (imagesItems) {

            let count = 0;
            fieldFootage.forEach(item => {
                if (item && count < imagesItems) {
                    galleryArr = [...galleryArr, item.img];
                    count++;
                }
            })


        }
        galleryArr.forEach(img => {
            fragment.appendChild(renderGalleryImg(img, title));
        })
        productImages.appendChild(fragment)
    }
    //


    //Render functions


    //Start sidebar functions
    function createFasAttributes() {
        const fasParentAttr = objectAttributesCreate(getElement('[data-fas]'));
        for (let key in fasParentAttr) {
            getElement('[data-fas]').setAttribute(`data-fas_attribute-${key}`, fasParentAttr[key])
        }
        ;
    }

    function renderBreadcrumbs() {

        const {breadcrumbs} = product;
        const parent = productItem.querySelector('.product-item__category');
        for (let key in breadcrumbs) {
            if (breadcrumbs[key]) {
                let {link, name} = breadcrumbs[key]
                parent.innerHTML += `<a href="${link}"> <span> ${name} </span> </a>`

            }
        }


    }

    function renderVariationsAttributes(renderAttributes) {
        let {images: {photos}, isHelmet, modal_size, variations} = product;
        const parent = productItem.querySelector('.product-item__attributes');
        const fragment = document.createDocumentFragment();
        for (let item of renderAttributes) {
            for (let key in item) {
                let {attrName, label, values} = item[key];

                const valuesArray = variations.map(obj => obj.attributes[attrName]);
                const div = document.createElement('div');
                div.classList = `product-item__${label.toLowerCase().split(' ').join('-')} product-item--line border--bottom`;
                const divHeader = document.createElement('div');
                divHeader.classList = 'flex --just-between  --align-center mb-10';
                divHeader.innerHTML = `<div class="mr-10">${label}</div>`;

                if (renderLabelButton(label)) {
                    const modalTrigger = document.createElement('button');
                    modalTrigger.classList = "flex --align-center product-item__modal-triger";
                    modalTrigger.dataset.modal = label.toLowerCase();
                    if (isHelmet && label == 'Protection level') {

                        modalTrigger.dataset.modal = 'protection helmet'
                    }
                    if (modal_size && label == 'Size') {
                        modalTrigger.dataset.modal = `${label.toLowerCase()}_${modal_size}`
                    }
                    modalTrigger.innerHTML = `
                          <span class="mr-5">${renderLabelButton(label)}</span>
                          <span class="icon-arrow-right icon-12"></span>`;
                    divHeader.appendChild(modalTrigger);
                }
                div.appendChild(divHeader);

                if (values.length == 1) {
                    div.classList.add('none')
                }
                div.appendChild(renderButtons(attrName, label, values, photos));

                if (attrName === 'pa_color') {
                    fragment.prepend(div)
                } else {
                    fragment.appendChild(div)
                }

            }
        }
        parent.appendChild(fragment)

    }


}

function findPlateVariation(currentAttributes) {
    let currentPlate = product.plate.find(plateItem => {
        return plateItem.links.find(el => {
            if (el.id === product.productId) {
                return el;
            }
        })
    }).links.find(el => el.id === product.productId)
    return currentPlate.variations.find(variation => {
        const {attributes} = variation;
        if (currentAttributes && Object.keys({...attributes, ...currentAttributes}).every(key => attributes[key] === currentAttributes[key])) return variation;
    })
}

function renderProductGallery(color, parent) {
    parent.innerHTML = '';
    const {images: {photos, gallery, fieldFootage}, title} = product;
    let galleryArr = [];
    const fragment = document.createDocumentFragment();

    if (!photos) return;
    photos.forEach(item => {
        if (item.slug && item.slug === color) {
            if (!item.colors) return
            const {colors} = item;
            colors.forEach(colorItem => {
                if (colorItem && colorItem.img) {
                    const {img} = colorItem;
                    if (galleryArr.length == 3) return;
                    galleryArr = [...galleryArr, img];
                }
            })
        }
    });
    if (galleryArr < 3) {
        console.log(67)
    }
    // gallery.forEach(item => {
    //     if (item.main) {
    //         galleryArr = [...galleryArr, item.main];
    //     }
    // });
    gallery.forEach(item => {
        if (!item.img) return;
        if (galleryArr.length == 3) return;
        galleryArr = [...galleryArr, item.img];
    });
    const imagesItems = 6 - galleryArr.length;
    if (imagesItems) {
        let count = 0;
        fieldFootage.forEach(item => {
            if (item && count < imagesItems) {
                galleryArr = [...galleryArr, item.img];
                count++;
            }
        })

    }
    if (imagesItems == 4) {
        gallery.forEach(item => {
            if (item.main) {
                galleryArr = [...galleryArr, item.main];
            }
        });
    }
    galleryArr.forEach(img => {
        fragment.appendChild(renderGalleryImg(img, title));
    })
    return fragment;
}

function getAlternativesProduct(object) {
    let newVariation = findVariation(object);

    if (newVariation && newVariation.in_stock) {
        return newVariation;
    }
    return;
}

function getAttributesObject(value) {
    if (!product || !product.attributes || !product.attributes.allAttributes) {
        return null;
    }

    const {attributes: {allAttributes}} = product;
    const attr = allAttributes.find(el => {
        if (Object.keys(el)[0] == value) {
            return el;
        }
    });
    return attr ? attr : null;

}

function getCurrentVariation() {
    let obj = {};
    productItem.querySelector('.product-item__attributes').querySelectorAll('[data-select]').forEach(attrParent => {
        attrParent.querySelectorAll('button').forEach(attr => {
            let key = attrParent.dataset.select
            if (attr.classList.contains('active')) {
                obj[key] = attr.getAttribute(`data-${key}`)
            }
        })
    })
    return obj;
}

function getAlternatives() {
    let alternatives = [];
    let obj = getCurrentVariation();


    if (product.alternatives) {
        product.alternatives.forEach(item => {
            let newObj = {...obj};
            if (!item.level_description) return;
            switch (item.level_description) {
                case 'Cummerbund type':

                    item.level_information.split('/').forEach(value => {
                        if (obj.pa_cummerbund !== value.toLowerCase().trim()) {

                            newObj.pa_cummerbund = value.toLowerCase().trim();
                            getAlternativesProduct(newObj) ? alternatives = [...alternatives, getAlternativesProduct(newObj)] : alternatives = [...alternatives];
                        }
                    })
                    break;
                case "Protection level":
                    if (obj['pa_protection-level']) {
                        switch (item.level_information) {
                            case 'All':
                                let protectionAttr = getAttributesObject('pa_protection-level')?.values;
                                if (!protectionAttr) return;
                                protectionAttr.forEach(value => {
                                    if (value.slug !== obj['pa_protection-level']) {
                                        newObj['pa_protection-level'] = value.slug;
                                        getAlternativesProduct(newObj) ? alternatives = [...alternatives, getAlternativesProduct(newObj)] : alternatives = [...alternatives];
                                    }
                                })
                                break
                            default:
                                break
                        }
                    }

                    break;
                case 'Color':

                    let colorAttr = getAttributesObject('pa_color')?.values;
                    if (!colorAttr) return;
                    colorAttr.forEach(value => {
                        if (value.slug !== obj.pa_color) {
                            newObj.pa_color = value.slug;
                            getAlternativesProduct(newObj) ? alternatives = [...alternatives, getAlternativesProduct(newObj)] : alternatives = [...alternatives];
                        }
                    })
                    break;
                case 'Size':
                    let sizeAttr = getAttributesObject('pa_size').values;
                    if (!sizeAttr) return;
                    switch (item.level_information) {
                        case 'One next':
                            sizeAttr.forEach((el, i) => {
                                if (el.slug == obj.pa_size) {
                                    if (sizeAttr[i + 1]) {
                                        newObj.pa_size = sizeAttr[i + 1].slug;
                                        if (newObj['pa_cummerbund-size']) {
                                            newObj['pa_cummerbund-size'] = sizeAttr[i + 1].slug;
                                        }
                                        getAlternativesProduct(newObj) ? alternatives = [...alternatives, getAlternativesProduct(newObj)] : alternatives = [...alternatives];
                                    }
                                }
                            })
                            break
                        case 'One previous':
                            sizeAttr.forEach((el, i) => {
                                if (el.slug == obj.pa_size) {
                                    if (sizeAttr[i - 1]) {
                                        newObj.pa_size = sizeAttr[i - 1].slug;
                                        if (newObj['pa_cummerbund-size']) {
                                            newObj['pa_cummerbund-size'] = sizeAttr[i - 1].slug;
                                        }
                                        getAlternativesProduct(newObj) ? alternatives = [...alternatives, getAlternativesProduct(newObj)] : alternatives = [...alternatives];
                                    }
                                }
                            });
                            break
                        case 'Another':
                            sizeAttr.forEach((el, i) => {
                                if (el.slug != obj.pa_size) {
                                    newObj.pa_size = el.slug;
                                    getAlternativesProduct(newObj) ? alternatives = [...alternatives, getAlternativesProduct(newObj)] : alternatives = [...alternatives];
                                }
                            });
                            break

                        default:
                            sizeAttr.forEach((el, i) => {
                                if (product.plate) {
                                    let currentPlate = product.plate.find(plateItem => {
                                        return plateItem.links.find(el => {
                                            if (el.id === product.productId) {
                                                return el;
                                            }
                                        })
                                    }).links.find(el => el.id === product.productId)
                                    if (el.slug == obj.pa_size) {
                                        if (sizeAttr[i - 1]) {
                                            let sizeObj = currentPlate.variations.find(variation => variation.attributes.pa_size == sizeAttr[i - 1].slug)
                                            if (sizeObj && sizeObj.in_stock) {
                                                let newItem = JSON.parse(JSON.stringify(product))
                                                newItem.alternative = sizeObj;
                                                alternatives = [...alternatives, newItem]
                                            }
                                        }
                                        if (sizeAttr[i + 1]) {
                                            let sizeObj = currentPlate.variations.find(variation => variation.attributes.pa_size == sizeAttr[i + 1].slug)
                                            if (sizeObj && sizeObj.in_stock) {
                                                let newItem = JSON.parse(JSON.stringify(product))
                                                newItem.alternative = sizeObj;
                                                alternatives = [...alternatives, newItem]
                                            }
                                        }
                                    }

                                } else {
                                    if (el.slug == obj.pa_size) {
                                        if (sizeAttr[i - 1]) {
                                            newObj.pa_size = sizeAttr[i - 1].slug;
                                            if (newObj['pa_cummerbund-size']) {
                                                newObj['pa_cummerbund-size'] = sizeAttr[i - 1].slug;
                                            }
                                            getAlternativesProduct(newObj) ? alternatives = [...alternatives, getAlternativesProduct(newObj)] : alternatives = [...alternatives];
                                        }
                                        if (sizeAttr[i + 1]) {
                                            newObj.pa_size = sizeAttr[i + 1].slug;
                                            if (newObj['pa_cummerbund-size']) {
                                                newObj['pa_cummerbund-size'] = sizeAttr[i + 1].slug;
                                            }
                                            getAlternativesProduct(newObj) ? alternatives = [...alternatives, getAlternativesProduct(newObj)] : alternatives = [...alternatives];
                                        }
                                    }
                                }


                            })
                            break;
                    }
                    break;
                case 'Type':
                    product.plate.forEach(plateItem => {
                        if (plateItem.name == item.level_description.toLowerCase()) {
                            // if (!plateItem.links.find(el => el.attrName == item.level_information))return;
                            let typeItem = null;
                            plateItem.links.forEach(el => {
                                if (el.attrName == item.level_information) {
                                    typeItem = JSON.parse(JSON.stringify(plateItem.links.find(el => el.attrName !== item.level_information)));
                                } else {
                                    if (plateItem.links.find(el => el.attrName == item.level_information)) {
                                        typeItem = JSON.parse(JSON.stringify(plateItem.links.find(el => el.attrName == item.level_information)));
                                    }
                                }
                            })
                            if (!typeItem) return;
                            let stockProduct = typeItem.variations.filter(elItem => elItem.in_stock).find(variation => {
                                const {attributes} = variation;
                                if (obj && ['pa_size'].every(key => attributes[key] === obj[key])) return variation;
                            });
                            if (stockProduct) {
                                typeItem.alternative = stockProduct;
                                alternatives = [...alternatives, typeItem]
                            }


                        }
                    })
                    break
                case 'Composite':
                    product.plate.forEach(plateItem => {
                        if (plateItem.name == item.level_description.toLowerCase()) {
                            item.level_information.split(', ').forEach(compositeProductId => {
                                if (!compositeProductId) return
                                const compositeItem = plateItem.links.find(el => el.id == compositeProductId);
                                if (!compositeItem) return
                                let stockProduct = compositeItem.variations.filter(elItem => elItem.in_stock).find(variation => {
                                    const {attributes} = variation;
                                    if (obj && ['pa_size'].every(key => attributes[key] === obj[key])) return variation;
                                });
                                if (stockProduct) {
                                    if (!compositeItem) return;
                                    let newItem = JSON.parse(JSON.stringify(compositeItem))
                                    newItem.alternative = stockProduct;
                                    alternatives = [...alternatives, newItem]
                                } else {
                                    stockProduct = compositeItem.variations.filter(elItem => elItem.in_stock);
                                    if (stockProduct && stockProduct.length > 0) {
                                        stockProduct.forEach(stockItem => {
                                            let newItem = JSON.parse(JSON.stringify(compositeItem))
                                            newItem.alternative = stockItem;
                                            alternatives = [...alternatives, newItem]
                                        })
                                    }
                                }
                            })
                        }
                    })

                    break
                case "Other product":
                    if (item.level_information && item.level_information.length > 0) {
                        if (product.plate) {
                            item.level_information.forEach(otherProduct => {
                                if (!otherProduct) return;
                                let newItem = JSON.parse(JSON.stringify(otherProduct))
                                newItem.plateAttr = []
                                otherProduct.plate.forEach(plateItem => {
                                    if (plateItem.name) {
                                        let obj = {};
                                        obj.name = plateItem.name
                                        obj.value = plateItem.links.find(el => el.id == newItem.productID).attrName
                                        newItem.plateAttr = [...newItem.plateAttr, obj]
                                    }
                                })
                                let stockProduct = otherProduct.variations.filter(elItem => elItem.in_stock);
                                if (stockProduct && stockProduct.length > 0) {
                                    stockProduct.forEach(stockItem => {
                                        let newPlate = JSON.parse(JSON.stringify(newItem))
                                        newPlate.alternative = stockItem;
                                        alternatives = [...alternatives, newPlate]
                                    })
                                }
                            })
                        } else {
                            item.level_information.forEach(el => {
                                const {variations} = el;
                                const element = variations.find(variation => {
                                    const {attributes} = variation;
                                    if (obj && Object.keys({...attributes, ...obj}).every(key => attributes[key] === obj[key])) return variation;
                                })
                                if (element && element.in_stock) {
                                    el.alternative = element
                                    alternatives = [...alternatives, el]
                                } else {
                                    let otherProduct = variations.filter(elItem => elItem.in_stock).find(variation => {
                                        const {attributes} = variation;
                                        if (obj && ['pa_color', 'pa_size'].every(key => attributes[key] === obj[key])) return variation;
                                    });
                                    el.alternative = otherProduct;
                                    if (otherProduct) {
                                        alternatives = [...alternatives, el]
                                    }

                                }
                            });
                        }

                    }
                    break;
            }
        })
        return alternatives;
    }

}


function alternativeDropdown(variationProduct) {
    const alternativeDropdownItem = productItem.querySelector('[data-dropdown]');
    if (!alternativeDropdownItem) return;

    if (!getElement('[data-fas]')) {
        if (variationProduct.in_stock) {

            if (!alternativeDropdownItem.classList.contains('disabled')) {
                return alternativeDropdownItem.classList.add('disabled')
            }
        } else {

            const {title, images: {photos}} = product;
            let photoPreview, photoPreviewMain = '';
            let alternatives = getAlternatives();
            let mainPlateAttr = '';
            if (product.plate) {
                product.plate.forEach(productItem => {
                    if (productItem.name === 'composite') {
                        let currentProductValue = productItem.links.find(el => el.id === product.productId);
                        if (currentProductValue) {
                            mainPlateAttr += `<span>${fixAttributeValue(currentProductValue.attrName)}</span>
                        `
                        }
                    }
                })
            }
            if (photos && photos.length > 0) {
                if (getAlternativePhotoPreview(variationProduct.attributes, product)) {
                    photoPreviewMain = getAlternativePhotoPreview(variationProduct.attributes, product);
                } else {
                    photoPreviewMain = getAlternativeColorPattern(variationProduct.attributes, product);
                }
            } else {
                photoPreviewMain = getAlternativeColorPattern(variationProduct.attributes, product);
            }
            const alternativeItemMain = `<li class="alternatives--line alternatives__item alternatives__item-main">
                            <div class="alternatives__photo image br--6">
                             ${photoPreviewMain}
                            </div>
                            <div class="alternatives__descr">
                                <div class="available text-color__warning">
                                    ${variationProduct.stock_status}
                                </div>
                                <div class="descr">
                                    <div class="name">${title}</div>
                                    <div class="info">${renderAttributesInfo(variationProduct)}
                                    ${mainPlateAttr}
                                    </div>
<!--                                    <div class="info">Black • Armored • M</div>-->
                                </div>
                            </div>
                        </li>`;
            const alternativeList = alternativeDropdownItem.querySelector('.dropdown__content').querySelector('.alternatives__list');
            if (!alternatives || !alternatives[0]) {
                alternativeList.innerHTML = '';
                alternativeList.nextElementSibling.classList.add('none');
                if (alternativeList.nextElementSibling.nextElementSibling && alternativeList.nextElementSibling.nextElementSibling.classList.contains('alternatives--line')) {
                    alternativeList.nextElementSibling.nextElementSibling.remove();
                }

                let fragment = `<div class="alternatives--line ">
                        <div class="btn cursor-default">No available alternatives</div>
                    </div>`
                alternativeList.nextElementSibling.insertAdjacentHTML('afterend', fragment)
                alternativeList.insertAdjacentHTML('beforeend', alternativeItemMain);
                return
            }


            ;


            alternativeDropdownItem.classList.remove('disabled');
            alternativeList.innerHTML = '';
            alternativeList.insertAdjacentHTML('beforeend', alternativeItemMain);
            if (alternativeList.nextElementSibling.classList.contains('none')) {
                alternativeList.nextElementSibling.nextElementSibling.remove()
                alternativeList.nextElementSibling.classList.remove('none');
            }
            let alternativeTitle = '';
            let alternativeStockStatus = '';
            let alternativeItem = '';
            if (product.plate) {
                photoPreview = getAlternativeColorPattern(alternatives[0].attributes, product);
                let itemPlateAttr = ''
                alternativeTitle = alternatives[0].title;
                itemPlateAttr += renderAttributesInfo(alternatives[0].alternative);
                let altId = '';
                let href = null;
                if (alternatives[0].id) {
                    altId = alternatives[0].id;
                    itemPlateAttr += `<span>${fixAttributeValue(alternatives[0].attrName)}</span>`;
                    href = alternatives[0].href;
                } else if (alternatives[0].productID) {
                    altId = alternatives[0].productID;
                    itemPlateAttr += `<span>Other product</span>`
                    href = alternatives[0].link;
                } else {
                    altId = alternatives[0].alternative.id;
                    itemPlateAttr = ''
                    alternatives[0].plate.forEach(productItem => {
                        if (productItem.name === 'composite') {
                            let currentProductValue = productItem.links.find(el => el.id === product.productId);
                            if (currentProductValue) {
                                itemPlateAttr += `<span>${fixAttributeValue(currentProductValue.attrName)}</span>
                        `
                            }
                        }
                    })

                }

                alternativeItem = `<li class="alternatives--line alternatives__item active border--bottom" data-alternative-id="${altId}">
                            <div class="alternatives__photo image br--6">
                             ${photoPreview}
                            </div>
                            <div class="alternatives__descr">
                                <div class="available text-color__success">
                                    In stock
                                </div>
                                <div class="descr text-color__black">
                                    <div class="name">${alternativeTitle}</div>
                                    <div class="info">${alternatives[0].id ? renderAttributesInfo(alternatives[0]) : renderAttributesInfo(alternatives[0].alternative)}
                                    ${itemPlateAttr}
                                    </div>

                                </div>
                            </div>
                        </li>`;
                if (href) {
                    alternativeList.insertAdjacentHTML('afterbegin', `<a href="${href}" class="txt-no-underline">${alternativeItem}</a>`)
                } else {
                    alternativeList.insertAdjacentHTML('afterbegin', alternativeItem)
                }


            } else {
                if (alternatives[0].id) {
                    if (photos && photos.length > 0) {
                        if (getAlternativePhotoPreview(alternatives[0].attributes, product)) {
                            photoPreview = getAlternativePhotoPreview(alternatives[0].attributes, product);
                        } else {
                            photoPreview = getAlternativeColorPattern(alternatives[0].attributes, product);
                        }
                    } else {
                        photoPreview = getAlternativeColorPattern(alternatives[0].attributes, product);
                    }
                } else {
                    const {images: {photos}} = alternatives[0];
                    if (photos && photos.length > 0) {
                        if (getAlternativePhotoPreview(alternatives[0].alternative.attributes, alternatives[0])) {
                            photoPreview = getAlternativePhotoPreview(alternatives[0].alternative.attributes, alternatives[0]);
                        } else {
                            photoPreview = getAlternativeColorPattern(alternatives[0].alternative.attributes, alternatives[0]);
                        }
                    } else {
                        photoPreview = getAlternativeColorPattern(alternatives[0].alternative.attributes, alternatives[0]);
                    }
                }
                alternativeTitle = alternatives[0].id ? title : alternatives[0].title;
                alternativeStockStatus = alternatives[0].id ? alternatives[0].stock_status : '';
                console.log(photoPreview, 'photoPreview 3')
                alternativeItem = `<li class="alternatives--line alternatives__item active border--bottom" data-alternative-id="${alternatives[0].id ? alternatives[0].id : alternatives[0].productId}">
                            <div class="alternatives__photo image br--6">
                                ${photoPreview}
                            </div>
                            <div class="alternatives__descr">
                                <div class="available text-color__success">
                                    ${alternativeStockStatus}
                                </div>
                                <div class="descr">
                                    <div class="name">${alternativeTitle}</div>
                                    <div class="info">${alternatives[0].id ? renderAttributesInfo(alternatives[0]) : renderAttributesInfo(alternatives[0].alternative)}
                        
                                    </div>

                                </div>
                            </div>
                        </li>`;
                alternativeList.insertAdjacentHTML('afterbegin', alternativeItem)
            }
        }
        productItem.querySelectorAll('.alternatives__item').forEach(
            alternativeItem => {
                if (alternativeItem.classList.contains('active')) {
                    alternativeItem.addEventListener('click', () => {
                        const attributesElements = productItem.querySelector('.product-item__attributes').querySelectorAll('[data-select]');
                        let alternativeVariation = null;
                        if (product.plate) {
                            let variations = {};
                            product.plate.forEach(plateItem => {
                                variations = plateItem.links.find(el => el.id == product.productId).variations;
                            })
                            alternativeVariation = variations.find(variation => variation.id == alternativeItem.dataset.alternativeId)
                        } else {
                            alternativeVariation = product.variations.find(el => el.id == alternativeItem.dataset.alternativeId);
                        }
                        let newPrice = +alternativeVariation.price !== +alternativeVariation.regular_price ? alternativeVariation.price : alternativeVariation.regular_price;
                        attributesElements.forEach(item => {
                            const btns = item.querySelectorAll('button');
                            installmentCalc(productItem);
                            btns.forEach(btn => {
                                removeActive(btns)
                                renderActiveAttributes(attributesElements, alternativeVariation, newPrice);
                                getVariationFromAttributesMainProduct(attributesElements);
                                if (btn.dataset.pa_color && btn.classList.contains('active')) {
                                    const productInformation = getElement('.product-item__information');
                                    const productImages = productInformation.querySelector('.product-item__gallery ').querySelector('.photos');
                                    productImages.innerHTML = '';
                                    productImages.appendChild(renderProductGallery(btn.dataset.pa_color, productImages))

                                }


                            })
                        });


                        if (!alternativeDropdownItem.classList.contains('disabled')) {
                            return alternativeDropdownItem.classList.add('disabled')
                        }
                    })
                }
            }
        )
    } else {
        const mainFas = getElement('[data-fas]');
        const stockLabel = alternativeDropdownItem.querySelector('[data-product-stock]');
        const alternativeList = alternativeDropdownItem.querySelector('.dropdown__content').querySelector('.alternatives__list');
        alternativeList.classList.add('alternatives__list-fas')

        function createIncludesVariations(item, fasObj) {
            if (!item) return;
            const {attributes: {variationsAttributes},} = item;
            let variation = {};
            for (let key of variationsAttributes) {
                for (let attr in fasObj) {
                    if (attr == key) {
                        variation[key] = fasObj[key]
                    }
                }
            }
            if (findVariationInProducts(variation, item)) {
                variation = findVariationInProducts(variation, item)
            } else {
                const {variations} = item;
                if (variation['pa_protection-level']) {
                    variation = variations.find(variationProduct => {
                        const {attributes} = variationProduct;
                        if (attributes['pa_size'].indexOf(variation['pa_size']) >= 0 && attributes['pa_protection-level'] === variation['pa_protection-level'] && attributes['pa_color'] === variation['pa_color']) return variationProduct;
                    })
                } else {
                    variation = variations.find(variationProduct => {
                        const {attributes} = variationProduct;
                        if (attributes['pa_cummerbund'] === "armored" && attributes['pa_color'] === variation['pa_color'] && attributes['pa_size'] === variation['pa_size'] && attributes['pa_cummerbund-size'] === variation['pa_size']) return variationProduct
                    })
                }
            }
            return variation;
        }

        let allIncludes = [];
        Object.values(product.fas).forEach(fasItem => {
            fasItem.includeAlternative = createIncludesVariations(fasItem, objectAttributesCreate(mainFas));
            allIncludes = [fasItem, ...allIncludes]
        })
        let includesNoStock = allIncludes.filter(el => !el.includeAlternative.in_stock);
        if (includesNoStock.length > 0) {
            stockLabel.classList = 'label  mr-15 label--gray'
            stockLabel.innerHTML = `<span class="icon-check flex   mr-5"><svg class="icon"><use xlink:href="#check"></use></svg></span><span>Check stock</span><div class="triangle"></div>`;
            alternativeList.innerHTML = '';
            allIncludes.forEach(includeItem => {
                console.log(includeItem, 'includeItem')
                let alternativeItem = `<li class="alternatives--line alternatives__item active border--bottom" data-alternative-id="${includeItem.productId}">
                            <div class="alternatives__photo image br--6">
                                 <img src="${includeItem.thumbnail}" alt="${includeItem.title}">
                            </div>
                            <div class="alternatives__descr">
                                <div class="available  ${includeItem.includeAlternative.in_stock ? 'text-color__success' : 'text-color__warning'}">
                                    ${includeItem.includeAlternative.stock_status}
                                </div>
                                <div class="descr">
                                    <div class="name">${includeItem.title}</div>
                                    <div class="info">${renderAttributesInfo(includeItem.includeAlternative)}
                                    </div>
                                </div>
                            </div>
                        </li>`;
                alternativeList.insertAdjacentHTML('afterbegin', alternativeItem)

            })


        } else {
            if (!alternativeDropdownItem.classList.contains('disabled')) {
                return alternativeDropdownItem.classList.add('disabled')
            }
            stockLabel.classList = 'label  mr-15 label--green'
            stockLabel.innerHTML = `<span class="icon-check flex   mr-5"><svg class="icon"><use xlink:href="#check"></use></svg></span><span>In stock</span>`

        }

        return;
    }

}

function renderActiveAttributes(attributesElements, obj, startPrice = null) {
    const priceParentEl = productItem.querySelector('[data-variation-price]');
    const regularpriceParentEl = productItem.querySelector('[data-price-old]');
    attributesElements.forEach(item => {
        const {currency, variations} = product;
        const currentCurrency = currency;
        const quantity = +priceParentEl.dataset.productQuantity;
        const btns = item.querySelectorAll('button');
        if (obj) {

            const {price, regular_price} = obj;
            priceParentEl.dataset.productPrice = Math.ceil(+price) * quantity;
            priceParentEl.innerHTML = `${currentCurrency}${Math.ceil(+price) * quantity}`
            regularpriceParentEl.dataset.priceOld = Math.ceil(+regular_price) * quantity;
            regularpriceParentEl.innerHTML = price !== regular_price ? currentCurrency + (Math.ceil(+regular_price) * quantity) : '';
            btns.forEach(btn => {
                for (let key in obj.attributes) {
                    if (key === item.dataset.select) {
                        if (btn.getAttribute(`data-${key}`) === obj.attributes[key]) {
                            btn.classList.add('active');
                            if (btn.children.length > 1) {
                                btn.lastChild.textContent = 'Included';

                            } else {
                                btn.insertAdjacentHTML('beforeend', `<span>Included</span>`)

                            }

                        }
                    }
                }

                let variationsItems = searchVariations(obj.attributes, variations);
                if (variationsItems.length == 0) {
                    if (!btn.classList.contains('active')) {
                        btn.classList.add('disabled')
                    }
                    return;
                }
                variationsItems.forEach(varItem => {

                    //TODO regularPrice = regular_price - change
                    const {price, regular_price, attributes, in_stock} = varItem;
                    if (btn.classList.contains('disabled')) btn.classList.remove('disabled');
                    for (let key in attributes) {
                        const valuesArray = variationsItems.map(obj => obj.attributes[key]);
                        if (btn.getAttribute(`data-${key}`) == attributes[key] && !btn.classList.contains('active') && valuesArray.includes(btn.getAttribute(`data-${key}`))) {
                            let value = 0;
                            if (+startPrice > +price) {
                                value = (+startPrice - +price).toFixed(2);
                                value = `-${currency}${+Math.ceil(value) * quantity}`
                            } else if (+startPrice < +price) {
                                value = (+price - +startPrice).toFixed(2);
                                value = `+${currency}${+Math.ceil(value) * quantity}`

                            } else {
                                value = ``;

                            }
                            if (btn.children.length > 1) {
                                btn.lastChild.innerHTML = `<span>${value}</span>`;
                            } else {
                                btn.insertAdjacentHTML('beforeend', `<span>${value}</span>`);
                            }
                            renderStockStatus(productItem, obj)
                            return;
                        }
                        if (!btn.classList.contains('active') && btn.getAttribute(`data-${key}`) && !valuesArray.includes(btn.getAttribute(`data-${key}`))) {
                            btn.classList.add('disabled')
                            if (btn.children.length > 1) {
                                btn.lastChild.remove();
                            }
                        }
                    }
                })

                return
            })
        }
    })
    let discount = Math.round((1 - +priceParentEl.dataset.productPrice / +regularpriceParentEl.dataset.priceOld) * 100);
    if (discount && discount != 0) {
        if (productItem.querySelector('[data-product-discount]').parentElement.classList.contains('none')) {
            productItem.querySelector('[data-product-discount]').parentElement.classList.remove('none')
        }

        productItem.querySelector('[data-product-discount]').innerText = `${discount}%`
    } else {
        productItem.querySelector('[data-product-discount]').parentElement.classList.add('none')
    }

    productItem.querySelector('.product-item__order button[data-cart]').classList.toggle('none', !obj.in_stock);
    productItem.querySelector('.product-item__order button[data-modal="report"]').classList.toggle('none', obj.in_stock);
    console.log(obj.in_stock, obj)

}

function getVariationFromAttributesMainProduct(attributesElements) {
    const {plate} = product;
    let obj = getCurrentVariation();
    let newVariation = findVariation(obj);
    if (!newVariation) {
        renderActiveAttributes(attributesElements, newVariation, newPrice);
        return
    }
    let newPrice = +newVariation.price !== +newVariation.regular_price ? newVariation.price : newVariation.regular_price;
    if (plate) {

        const {attributes: {pa_size}} = newVariation
        productItem.querySelectorAll('[data-plate]').forEach(item => {
            item.querySelectorAll('a').forEach(a => {
                const linkStr = a.href
                const [href] = linkStr.split('?attribute_pa_size=');
                a.href = `${href}?attribute_pa_size=${pa_size}`
            })
        })
        let currentItem = findPlateVariation(obj)
        newPrice = +currentItem.price !== +currentItem.regular_price ? currentItem.price : currentItem.regular_price;
        getElement('.product-item__main').dataset.productId = currentItem.id;
        renderActiveAttributes(attributesElements, currentItem, newPrice);
        // productItem.dataset.productId = defaultItem.id;
        alternativeDropdown(currentItem)
    } else {

        getElement('.product-item__main').dataset.productId = newVariation.id
        renderActiveAttributes(attributesElements, newVariation, newPrice);
        alternativeDropdown(newVariation)
    }
}

function renderAttributesInfo(variationProduct) {
    let info = []
    if (variationProduct.attributes) {
        for (let key in variationProduct.attributes) {
            if (key == 'pa_color') {
                info = [findAttributeValue(variationProduct.attributes, key), ...info];
            }
            if (key !== 'pa_cummerbund-size' && key !== 'pa_color') {
                info = [...info, findAttributeValue(variationProduct.attributes, key)];
            }
        }
    }
    let attributesInfo = '';
    info.forEach(value => {
        attributesInfo += `<span>${value}</span>`;

    })
    return attributesInfo;
}

function renderLabelButton(type) {
    switch (type.toLowerCase()) {
        case 'color':
            return 'Details';

        case 'protection level':
            return 'How to choose';
        case 'size':
            return 'Size calculator';
        default:
            return false;
    }

}

function renderButtons(attrName, label, values, photos, activeVariations = null) {
    const div = document.createElement('div');
    values.forEach(item => {
        const {slug, value, pattern} = item;
        div.dataset.select = `${attrName}`;
        div.dataset.sizeType = 'size';
        div.classList = 'product-item__buttons flex product-item__buttons--height-auto';
        const btn = document.createElement('button');
        btn.classList = 'btn btn--outline  --dir-col';
        btn.innerHTML = ` <span>${value}</span>`;
        btn.setAttribute(`data-${attrName}`, slug)
        btn.dataset.selectItem = '';
        if (attrName === 'pa_color') {
            div.classList = 'colors flex scroll--y';
            btn.classList = 'br--6';

            if (photos && photos.length > 0) {
                let photo = photos.find(el => el.slug == slug);
                if (photo) {
                    btn.innerHTML = `<div class="image"><img src="${photo.colors[0].thumbnail}" alt="${value}"></div>`;
                } else {
                    btn.classList.add('pattern-img');
                    btn.innerHTML = `<div class="image"><img src="${pattern}" alt="${value}"></div>`;
                }
            } else {
                btn.classList.add('pattern-img');
                btn.innerHTML = `<div class="image"><img src="${pattern}" alt="${value}"></div>`;
            }
        }
        if (activeVariations && !activeVariations.includes(slug)) {
            btn.classList.add('disabled')
        }
        div.appendChild(btn)
    })


    return div;

}

function renderRatingHTML(el, rating) {

    const parent = el.querySelector('.stars');

    let fragment = '';
    let arr = [1, 2, 3, 4, 5]
    let newArr = []


    for (let j = 1; j <= Math.round(+rating); j++) {

        if (arr[j - 1] == j) {
            fragment += `
          <span class="star">
             <svg class="icon" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.912 3L17.5864 11.231H26.241L19.2393 16.318L21.9137 24.549L14.912 19.462L7.91031 24.549L10.5847 16.318L3.58302 11.231H12.2376L14.912 3Z" fill="#111111"/>
             </svg>
           </span>
        `;

            newArr = ['full', ...newArr]


        }
    }
    if (!Number.isInteger(+rating) && !(Math.round(+rating) - Math.trunc(+rating))) {

        newArr = [...newArr, 'hulf']
        fragment +=
            `              <span class="star">
                 <svg class="icon"viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.912 3L17.5864 11.231H26.241L19.2393 16.318L21.9137 24.549L14.912 19.462L7.91031 24.549L10.5847 16.318L3.58302 11.231H12.2376L14.912 3Z" fill="#000" fill-opacity="0.4"/>
                    <path d="M7.90932 24.549L14.911 19.462V3L12.2366 11.231H3.58203L10.5837 16.318L7.90932 24.549Z" fill="#111111"/>
               </svg>
               </span>`;
    }
    if (newArr.length < 5) {
        for (let i = 1; i <= arr.length; i++) {
            if (!newArr[i - 1]) {
                newArr = [...newArr, 'empty'];
                fragment += `
          <span class="star empty">
             <svg class="icon" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.912 3L17.5864 11.231H26.241L19.2393 16.318L21.9137 24.549L14.912 19.462L7.91031 24.549L10.5847 16.318L3.58302 11.231H12.2376L14.912 3Z" fill="#111111"/>
             </svg>
           </span>
        `;
            }
        }
    }
    parent.innerHTML = fragment
}


function installmentCalc(el) {
    if (!el.querySelector('[data-installment]')) return
    let priceEl = el.querySelector('[data-product-price]')
    el.querySelector('[data-installment]').innerText = `$${Math.ceil(+priceEl.dataset.productPrice / 4)}`;
}

function findVariation(findObj) {
    const {variations} = product;
    return variations.find(variation => {
        const {attributes} = variation;
        if (findObj && Object.keys({...attributes, ...findObj}).every(key => attributes[key] === findObj[key])) return variation;
    })
}

function renderGalleryImg(img, title) {
    const div = document.createElement('div');
    div.classList = 'photos__item br--16 pos-r ';
    div.innerHTML = `
                        <div class="image">
<!--                            <img src="${img}" alt="${title}">-->
     ${img}
                        </div>
                        `
    return div;
}

function calcCashBack(el) {
    const price = +el.querySelector('[data-product-price]').dataset.productPrice;
    let cashBack = +el.querySelector('[data-product-cashback]').dataset.productCashback;
    getElement('[data-product-cashback]').querySelector('span').innerText = `$${Math.round(cashBack / 100 * price)}`
}

function renderStockStatus(parent, obj) {
    const stock = parent.querySelector('[data-product-stock]');
    // if (!stock) return
    const {in_stock, stock_status} = obj;
    let inStock = in_stock ? true : false;
    let clazz = 'label  mr-15'
    let descr = '';
    if (inStock) {
        clazz += ' label--green';
        descr = `<span class="icon-check flex   mr-5"><svg class="icon"><use xlink:href="#check"></use></svg></span><span>In stock</span>`
    } else {
        clazz += in_stock ? ' label--green' : ' label--gray';
        descr = `<span class="icon-check flex   mr-5"><svg class="icon"><use xlink:href="#check"></use></svg></span><span>Check stock</span><div class="triangle"></div>`;
    }
    if (stock) {
        stock.innerHTML = descr;
        stock.classList = clazz;
    }


}

function searchVariations(obj, arr) {
    let matches = [];

    arr.forEach(item => {
        let {attributes} = item;
        let i = 0;
        for (let key in obj) {
            let s = obj[key];

            if (attributes[key] == s) {
                i++;
            }
        }

        if (i == Object.keys(obj).length - 1) {

            matches = [item, ...matches];
        }


    })


    return matches;
}

function renderQuantityChanger() {

    const fragment = `<div class="product-item__includes  product-item--line border--bottom"> 
        <div class="flex --just-between  --align-center">
            <div class="mr-10">Quantity</div>
            <div class="cart__counter flex --align-center text-color__black">
            <button class="flex-inline --align-center --just-center"><span class="minus "></span>
            </button>
            <div class="result txt-center h3 fw-600">1</div>
            <button class="flex-inline --align-center --just-center"><span class="plus "></span></button>
            </div>
        </div>
     </div>`
    return fragment
}

function findAttributeSlug(personalValue, productAttr, attrName = 'pa_size') {
    let values = Object.values(productAttr).find((attribute) => Object.keys(attribute)[0] == attrName)
    if (values && Object.values(values).length) {
        let valueAttr = Object.values(values)[0].values.find(({value}) => value == personalValue)
        if (valueAttr) return valueAttr.slug
    }

}

function findAttributeValue(variationProduct, key) {
    let values = Object.values(product.attributes.allAttributes).find((attribute) => Object.keys(attribute)[0] == key);
    if (values && Object.values(values).length) {
        let valueAttr = Object.values(values)[0].values.find(({slug}) => slug == variationProduct[key])
        if (valueAttr) return valueAttr.value;
    }
}

function findPersonalColor(personalValue, allAttributes) {
    let values = Object.values(allAttributes).find((attribute) => Object.keys(attribute)[0] == 'pa_color')
    if (values && Object.values(values).length) {
        let isColor = Object.values(values)[0].values.find(({slug}) => slug == personalValue)
        if (isColor) return true
    }
}

export {
    findVariation,
    renderGalleryImg,
    productItem,
    renderLabelButton,
    searchVariations,
    renderButtons,
    installmentCalc,
    calcCashBack,
    renderStockStatus,
    renderRatingHTML,
    getVariationFromAttributesMainProduct,
    getAlternatives,
    getCurrentVariation,
    renderActiveAttributes,
    renderProductGallery, findPlateVariation, findAttributeSlug, findPersonalColor, findAttributeValue
};